import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=2147656d&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"
import style0 from "./Step1.vue?vue&type=style&index=0&id=2147656d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147656d",
  null
  
)

export default component.exports